import React from 'react';
import {_GPY,__GPYPost} from '../env.js'

class BugReport extends React.Component {
  constructor(props) {
   super(props);
   this.state = {
     comment:"your comment",
     prio:"Normal"
   };
  }

  componentDidMount(){
  }

  sendBugreport(){
    var obj = {};
    obj.userId = _GPY.uiStates.userID;
    obj.userName = _GPY.uiStates.userName;
    obj.currentTime = new Date().toString();
    obj.log = _GPY.log;
    obj.comment = this.state.comment;
    obj.prio = this.state.prio;
    __GPYPost('bugReport',obj,(res)=>{
    });
    alert("BugReport transmit");
  }

	render() {

    return (
      <div>
        <div className="row">
          <div className="col-12">
          <form>
            <div class="form-group">
              <label for="exampleFormControlSelect1">Prio</label>
              <select class="form-control" id="exampleFormControlSelect1"  onChange={(e)=>this.setState({prio:e.target.value})}>>
                <option>LOW</option>
                <option selected>Normal</option>
                <option>High</option>
              </select>
            </div>
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Comment</label>
              <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" onChange={(e)=>this.setState({comment:e.target.value})}>{this.state.comment}</textarea>
            </div>
          </form>
          <button onClick={()=>{this.sendBugreport();this.props.setGameType("Dashboard");}} type="button" class="btn btn-primary mb-2">Send BugReport</button>
          </div>
        </div>
      </div>
		 	);
    }
}
export default BugReport;
